/* eslint-disable import/no-anonymous-default-export */
export default {
  header: {
    home: 'Accueil',
    product: 'Produit',
    devex: 'DevEx & IDP',
    astrolabe: 'Astrolabe IDP',
    team: 'Équipe',
    contact: 'Get Started'
  },
  footer: {
    language: 'Langue',
    termsOfUse: 'Conditions d\'utilisation',
    privacyStatement: 'Politique de confidentialité',
    cookiePreferences: 'Préférences de cookies',
    description: 'Astrolabe est un Portail de Développement Interne développé et conçu avec Backstage©, par Forge IT'
  },
  hero: {
    title: 'Astrolabe',
    subtitle: 'Internal Developer Portal',
    description1: 'Développé et conçu avec',
    description2: 'pour améliorer l\'expérience développeur.'
  },
  ourProduct: {
    title: 'Notre Produit',
    description1: 'Notre Portail de Développement Interne (IDP), basé sur le moteur open-source Backstage, est conçu pour centraliser les outils, les documentations et les ressources techniques nécessaires aux développeurs.',
    description2: 'Nous fournissons une solution facile à utiliser, sécurisée et personnalisable pour nos clients.',
    roi: {
      title: 'Votre R.O.I',
      subtitle: 'Indicateurs clés avec un IDP',
      onboarding: 'de réduction du temps d\'intégration pour les nouveaux développeurs',
      incidents: 'de réduction des incidents en production',
      deployment: 'de réduction du temps de déploiement',
      development: 'd\'augmentation du temps de développement effectif'
    },
    cards: {
      openSource: {
        title: 'Open Source',
        description: 'Le support de la communauté massive et l\'open source apportent flexibilité et innovation continue.'
      },
      security: {
        title: 'Sécurité et fiabilité',
        description: 'Plateforme SaaS sécurisée',
        subDescription: '(Réseau, Données, Sauvegarde).'
      },
      ux: {
        title: 'UX / UI',
        description: 'Interface optimisée, données personnalisées.'
      },
      modular: {
        title: 'Architecture modulaire',
        description: 'Architecture nativement basée sur les plugins.'
      },
      popularity: {
        title: 'Popularité',
        description: 'Déjà adoptée et utilisée par de nombreux développeurs.'
      },
      accessibility: {
        title: 'Accessibilité',
        description: 'Config et plugins accessibles, sans code ni interruption.'
      },
      updated: {
        title: 'Mise à jour',
        description: 'Mises à niveau des outils gérées par notre équipe'
      }
    }
  },
  devEx: {
    title: 'DevEx & IDP',
    developerExperience: {
      title: 'Expérience Développeur',
      description1: 'L\'Expérience Développeur est un ensemble d\'interactions, d\'outils, de processus et d\'environnements qui influencent la façon dont les développeurs travaillent et créent des logiciels.',
      description2: 'Une bonne DevEx vise à rendre le travail des développeurs fluide, productif et agréable, en offrant :',
      listItems: {
        0: 'Des outils intuitifs et efficaces,',
        1: 'Une documentation claire,',
        2: 'Un accès simplifié aux ressources,',
        3: 'Et des processus qui réduisent les obstacles techniques ou organisationnels'
      }
    },
    backstage: {
      title: 'Backstage',
      description: 'est un Framework open-source développé par Spotify pour implémenter un IDP.',
      listItems: {
        0: 'Catalogue d\'applications avec graphes de dépendances',
        1: 'Création d\'un nouveau dépôt Git basé sur des modèles',
        2: 'Intégration avec votre CI/CD',
        3: 'Déclenchement de build et affichage de l\'historique des statuts',
        4: 'Suivi des versions de déploiement par environnement',
        5: 'Centralisation de la documentation technique',
        6: 'Collecte des problèmes de santé et des métriques pour vos composants'
      }
    },
    growth: {
      title: 'Croissance et Adoption',
      emergingMarket: {
        title: 'Marché émergent :',
        text: 'Le marché des IDPs connaît une croissance significative, portée par l\'adoption des pratiques DevOps et la complexité croissante des infrastructures cloud'
      },
      trend: {
        title: 'Tendance 2024 :',
        text: 'Les enquêtes indiquent que 85% des organisations ont déjà mis en œuvre ou prévoient d\'adopter un IDP au cours de la prochaine année, particulièrement dans les industries technologiques'
      },
      enterprise: {
        title: 'Adoption par les entreprises :',
        text: 'Les moyennes et grandes entreprises sont à l\'avant-garde, se concentrant sur la réduction du time-to-market et l\'amélioration de la productivité des développeurs'
      }
    },
    keyDrivers: {
      title: 'Facteurs clés des IDPs',
      simplification: {
        title: 'Besoin de simplification :',
        text: 'Les IDPs simplifient les pipelines de développement en fournissant des environnements standardisés, prêts à l\'emploi pour les développeurs, réduisant les frictions dans les flux de travail'
      },
      devops: {
        title: 'Impact du DevOps et des micro-services :',
        text: 'L\'essor des micro-services et des outils d\'orchestration augmente la demande d\'un IDP pour simplifier la gestion des infrastructures complexes'
      },
      objective: {
        title: 'Objectif principal :',
        text: 'Automatiser les tâches manuelles répétitives et offrir des environnements évolutifs en libre-service pour autonomiser les développeurs et stimuler l\'agilité dans la livraison de logiciels'
      }
    }
  },
  astrolabe: {
    title: 'Fonctionnalités natives supplémentaires',
    subtitle: 'par rapport à Backstage',
    features: {
      pluginsManagement: 'Gestion des plugins dans l\'interface',
      usersGroups: 'Gestion des utilisateurs et des groupes',
      customDashboard: 'Tableau de bord personnalisé',
      releasesManagement: 'Gestion des versions',
      scorecard: 'Tableau de bord de performance',
      gamification: 'Gamification',
      doraMetrics: 'Métriques DORA',
      andMore: 'Et plus encore...'
    }
  },
  ourTeam: {
    title: 'À propos de nos services et expertise',
    description: 'Nous vous accompagnons tout au long de cette transformation :',
    steps: {
      audit: 'Audit',
      integration: 'Intégration',
      changeManagement: 'Gestion du changement & Formation',
      support: 'Support & Expertise technique'
    },
    expertise: {
      introduction: 'Notre équipe assure votre succès en exploitant notre expertise en :',
      items: {
        devEx: 'Expérience développeur, optimisation des flux de travail et amélioration de la productivité',
        cicd: 'CI/CD & Industrialisation, accélération des cycles de développement et amélioration de l\'efficacité',
        devops: 'DevOps, favorisant la collaboration et l\'automatisation des processus pour une innovation continue',
        security: 'Sécurité, assurant une protection robuste avec les normes les plus élevées de l\'industrie'
      }
    }
  },
  contactUs: {
    title: 'Prêts à booster votre DevEx ?',
    subtitle: 'Qualifions vos besoins',
    button: 'Démarrer l\'évaluation'
  }
};
